import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { LUCIDE_ICONS, LucideIconProvider, QrCode, FileText, Camera, X, TriangleAlert, RotateCcw, Ban, CircleCheck, CloudCheck, Wifi, WifiOff, CloudUpload, MapPin, LogOut, Info, Zap } from 'lucide-angular';
import { environment } from '@env/environment';

import { routes } from './app.routes';
import { ENV_CONFIG } from '@core/config/env.token';
import { provideServiceWorker } from '@angular/service-worker';
import { globalHttpErrorInterceptor } from '@core/http/global-http-error-interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        globalHttpErrorInterceptor
      ])
    ),
    {
      provide: LUCIDE_ICONS,
      multi: true,
      useValue: new LucideIconProvider({
        QrCode,
        FileText,
        Camera,
        MapPin,
        LogOut,
        X,
        TriangleAlert,
        RotateCcw,
        Ban,
        CircleCheck,
        CloudCheck,
        Wifi,
        WifiOff,
        CloudUpload,
        Info,
        Zap
      })
    },
    { provide: ENV_CONFIG, useValue: environment },
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.serviceWorkerEnabled === true,
      registrationStrategy: 'registerWhenStable:30000'
    })
  ]
};
